import React from "react";
import { Formik } from "formik";
import * as formsService from "../../../services/formsService";
import { validationSchema } from "../InterviewPatientInfoScreening/validationSchema";
import OnSubmitValidationError from "../../../components/FormComponents/OnSubmitValidationError";
import { connect } from "react-redux";
import * as interviewActions from "../../../actions/interviewActions";
import { ExpensesField } from "../../../components/FormComponents/LiabilitiesQuestionFields";
import { WizardButtonsField } from "../Components/WizardButtons";

export const InterviewTexas = ({
    patientFullName,
    navigateToNextPage,
    navigateToPreviousPage,
    liabilities,
    setLiabilities,
    onError,
    expenseTypes,
}) => {
    const onFormSubmit = formData => {
        let debts = [];
        let expenses = [];
        if (formData.hasMajorMonthlyExpenses) {
            expenses = formData.expenses;
        }
        if (liabilities.debts != null) {
            debts = liabilities.debts;
        }

        const dataToSubmit = {
            expenses,
            debts,
        };
        setLiabilities(dataToSubmit);
    };

    const initialValues = {
        hasMajorMonthlyExpenses: liabilities.expenses.length > 0,
        expenses: liabilities.expenses,
    };

    return (
        <Formik
            onSubmit={onFormSubmit}
            initialValues={initialValues}
            render={props => {
                const { setFieldValue, setFieldTouched, resetForm, handleSubmit, errors, touched, values } = props;
                const getValidationState = formsService.getValidationState.bind(this, errors, touched);
                const getErrors = formsService.getErrors.bind(this, errors);
                const isRequired = formsService.isRequired.bind(this, validationSchema, values);
                return (
                    <form className="wizard-form">
                        <OnSubmitValidationError callback={onError} />
                        <ExpensesField
                            setFieldValue={setFieldValue}
                            thePatient={patientFullName}
                            expenseTypes={expenseTypes}
                            getErrors={getErrors}
                            getValidationState={getValidationState}
                            setFieldTouched={setFieldTouched}
                            values={values}
                            props={props}
                        />
                        <WizardButtonsField
                            shouldAutoNavigate={false}
                            navigateToNextPage={navigateToNextPage}
                            navigateToPreviousPage={navigateToPreviousPage}
                        />
                    </form>
                );
            }}
        />
    );
};

export const InterviewTexasContainer = connect(
    state => ({
        patientFullName: state.interview.entry.patient.fullName,
        patientAge: state.interview.entry.patient.age,
        expenseTypes: state.interviewLookups.data.expenseType,
        liabilities: state.interview.liabilities,
    }),
    dispatch => ({
        onError: () => dispatch(interviewActions.setInterviewError("info")),
        setLiabilities: liabilities => dispatch(interviewActions.setLiabilities(liabilities)),
    })
)(InterviewTexas);
